import type { OrderHistoryRow } from "@/lib/orders";

const BERLIN_TIME_ZONE = "Europe/Berlin";

export function fmtOrderDate(value: string | undefined | null): string {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleDateString("de-DE", { timeZone: BERLIN_TIME_ZONE });
}

export function fmtOrderDateTime(value: string | undefined | null): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("de-DE", {
    timeZone: BERLIN_TIME_ZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function splitBestellnummern(raw: string | null | undefined): string[] {
  return String(raw || "")
    .split(/[,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function submissionChannelLabel(channel: string | null | undefined): string | null {
  switch (channel) {
    case "graph":
      return "Direkt (Microsoft)";
    case "mailto":
      return "Mail-Programm";
    case "copy":
      return "Nummer kopiert";
    case "excel":
      return "Excel";
    default:
      return null;
  }
}

export function deliveryLabel(order: OrderHistoryRow): string | null {
  if (order.lieferart === "abholung") return "Abholung";
  const abk = (order.lieferadresse_abkuerzung || "").trim();
  return abk || null;
}

export type OrderHistorySortKey = "newest" | "oldest" | "undelivered_first" | "delivered_first";

export const ORDER_HISTORY_SORT_OPTIONS: { value: OrderHistorySortKey; label: string }[] = [
  { value: "newest", label: "Neueste zuerst" },
  { value: "oldest", label: "Älteste zuerst" },
  { value: "undelivered_first", label: "Nicht geliefert zuerst" },
  { value: "delivered_first", label: "Geliefert zuerst" },
];

export function sortOrderHistoryRows(
  rows: OrderHistoryRow[],
  sort: OrderHistorySortKey,
): OrderHistoryRow[] {
  const sorted = [...rows];
  sorted.sort((a, b) => {
    if (sort === "undelivered_first" || sort === "delivered_first") {
      const aDelivered = a.geliefert_at ? 1 : 0;
      const bDelivered = b.geliefert_at ? 1 : 0;
      if (aDelivered !== bDelivered) {
        return sort === "undelivered_first" ? aDelivered - bDelivered : bDelivered - aDelivered;
      }
    }
    const aTime = Date.parse(a.created_at || "") || 0;
    const bTime = Date.parse(b.created_at || "") || 0;
    if (sort === "oldest") return aTime - bTime || a.id - b.id;
    return bTime - aTime || b.id - a.id;
  });
  return sorted;
}
